import { useIntl } from 'react-intl';

import InformationCircle from '@/assets/icons/information-circle.svg';
import { Banner } from '@/components/ui/banner';
import { BOOST, ZIPRECRUITER } from '@/types/channels';

import { useChannelsStore } from '../use-channels-store';

interface ChannelCannotBePausedBannerProps {
  channelSlug: string;
  status: string;
}

export function ChannelCannotBePausedBanner({
  channelSlug,
  status,
}: ChannelCannotBePausedBannerProps) {
  const intl = useIntl();

  const lastAutomationChannel = useChannelsStore(s => s.lastAutomationChannel);
  const lastAutomationReason =
    lastAutomationChannel?.deactivation_reason ?? null;

  /* Show banner if the channel is Boost or ZipRecruiter and the channel is active or stopped and there is a last automation reason */
  const showBanner =
    (channelSlug === BOOST || channelSlug === ZIPRECRUITER) &&
    (status === 'active' || status === 'stopped') &&
    !!lastAutomationReason;

  if (!showBanner) return null;

  return (
    <Banner
      color="neutral"
      description={intl.formatMessage({
        defaultMessage:
          "This channel can't be paused once started. Once live, this campaign will continue until it ends automatically.",
      })}
      borderLess
      icon={<img src={InformationCircle} alt="Information" />}
      className="[&>div>p:last-child]:!text-fx-neutral-600 mx-5 mb-5"
    />
  );
}
